import React from "react";
import { IconsType } from "../../libs/Utils/types";

function Users({ height, width, fill }: IconsType) {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M60.0039 62.6319C68.2882 62.6319 75.0039 55.5627 75.0039 46.8425C75.0039 38.1222 68.2882 31.0531 60.0039 31.0531C51.7196 31.0531 45.0039 38.1222 45.0039 46.8425C45.0039 55.5627 51.7196 62.6319 60.0039 62.6319Z"
          fill={fill || "#F0EFEE"}
        />
        <path
          d="M55.0039 78.4213H65.0039C70.3082 78.4213 75.3953 80.6394 79.146 84.5875C82.8968 88.5356 85.0039 93.8904 85.0039 99.4739V110H35.0039V99.4739C35.0039 93.8904 37.111 88.5356 40.8618 84.5875C44.6125 80.6394 49.6996 78.4213 55.0039 78.4213Z"
          fill={fill || "#F0EFEE"}
        />
        <path
          d="M75.0039 46.8425C75.0002 43.1214 73.7456 39.5217 71.4624 36.681C69.1791 33.8402 66.0145 31.9416 62.5289 31.3215"
          fill={fill || "#F0EFEE"}
        />
        <path
          d="M82.5039 10.0005C78.9115 10.0121 75.3888 11.0452 72.3084 12.9908C69.2279 14.9363 66.7041 17.722 65.0039 21.0531C70.6473 22.2737 75.7181 25.5055 79.3614 30.2034C83.0047 34.9013 84.9976 40.778 85.0039 46.8425C84.9956 48.5399 84.8281 50.2323 84.5039 51.8951C89.6164 51.383 94.3442 48.8148 97.7028 44.7253C101.061 40.6358 102.792 35.3402 102.534 29.9412C102.277 24.5421 100.05 19.4558 96.3192 15.7414C92.588 12.0269 87.6394 9.97053 82.5039 10.0005Z"
          fill={fill || "#F0EFEE"}
        />
        <path
          d="M46.8339 69.1161C42.5664 66.3028 39.194 62.2123 37.1489 57.3688H35.0039C28.3759 57.3771 22.0217 60.1524 17.335 65.0857C12.6483 70.019 10.0118 76.7077 10.0039 83.6845V94.2108C10.0039 95.6066 10.5307 96.9453 11.4684 97.9324C12.4061 98.9194 13.6778 99.4739 15.0039 99.4739H25.0039C25.0153 92.6043 27.1521 85.9255 31.0908 80.4481C35.0296 74.9707 40.556 70.9927 46.8339 69.1161Z"
          fill={fill || "#F0EFEE"}
        />
        <path
          d="M85.0039 57.3688H82.8589C80.8138 62.2123 77.4415 66.3028 73.1739 69.1161C79.4518 70.9927 84.9783 74.9707 88.917 80.4481C92.8558 85.9255 94.9925 92.6043 95.0039 99.4739H105.004C106.33 99.4739 107.602 98.9194 108.539 97.9324C109.477 96.9453 110.004 95.6066 110.004 94.2108V83.6845C109.996 76.7077 107.36 70.019 102.673 65.0857C97.9861 60.1524 91.6319 57.3771 85.0039 57.3688Z"
          fill={fill || "#F0EFEE"}
        />
        <path
          d="M35.0039 46.8425C35.0103 40.778 37.0031 34.9014 40.6464 30.2034C44.2897 25.5055 49.3605 22.2738 55.0039 21.0531C53.3715 17.8626 50.9821 15.1713 48.0684 13.2411C45.1546 11.311 41.8158 10.2079 38.3769 10.0391C34.9379 9.87032 31.5161 10.6416 28.4443 12.2779C25.3726 13.9143 22.7557 16.3599 20.8483 19.3767C18.9409 22.3935 17.808 25.8787 17.56 29.4932C17.3119 33.1076 17.957 36.7281 19.4326 40.0022C20.9082 43.2763 23.1639 46.0924 25.9803 48.1766C28.7967 50.2607 32.0776 51.5418 35.5039 51.8951C35.1797 50.2324 35.0122 48.5399 35.0039 46.8425Z"
          fill={fill || "#F0EFEE"}
        />
      </svg>
    </div>
  );
}

export default Users;
